<template>
  <ValidationObserver v-slot="{ invalid, handleSubmit }">
    <div v-if="!loadingAccept">
      <el-form @submit.native.prevent="handleSubmit(onSubmit)" label-position="top">
        <el-row :gutter="20">
          <el-col :span="12">
            <ValidationProvider name="Tên khách hàng" rules="" v-slot="{ errors }">
              <label for="">Tên khách hàng <span class="text-danger">*</span></label>
              <el-form-item :error="errors[0]">
                <el-input
                  disabled
                  v-model="contract.name"
                  placeholder="Nguyễn Thị Tuyết Nhung"
                />
              </el-form-item>
            </ValidationProvider>
          </el-col>

          <el-col :span="12">
            <ValidationProvider name="Ngày sinh" rules="" v-slot="{ errors }">
              <label for="">Ngày sinh <span class="text-danger">*</span></label>
              <el-form-item :error="errors[0]">
                <el-input
                  disabled
                  v-model="contract.birthday"
                  placeholder="Nhập ngày sinh"
                />
              </el-form-item>
            </ValidationProvider>
          </el-col>

          <el-col :span="12">
            <ValidationProvider name="Số điện thoại" rules="" v-slot="{ errors }">
              <label for="">Số điện thoại <span class="text-danger">*</span></label>
              <el-form-item :error="errors[0]">
                <el-input disabled v-model="contract.phone" placeholder="Chọn khu vực" />
              </el-form-item>
            </ValidationProvider>
          </el-col>

          <el-col :span="12">
            <ValidationProvider name="Email" rules="" v-slot="{ errors }">
              <label for="">Email <span class="text-danger">*</span></label>
              <el-form-item :error="errors[0]">
                <el-input disabled v-model="contract.email" placeholder="Nhập email" />
              </el-form-item>
            </ValidationProvider>
          </el-col>

          <el-col :span="24">
            <ValidationProvider
              name="Lý do thay đổi"
              rules="required"
              v-slot="{ errors }"
            >
              <label for=""
                >Lý do thay đổi tài khoản thanh toán
                <span class="text-danger">*</span></label
              >
              <el-form-item :error="errors[0]">
                <el-input v-model="reason" placeholder="Nhập lý do" type="textarea" />
              </el-form-item>
            </ValidationProvider>
          </el-col>
        </el-row>
        <div class="dialog-footer text-right rounded">
          <el-button class="text-black" style="background-color: #cacaca" @click="close"
            >Huỷ bỏ</el-button
          >
          <el-button
            class="text-white"
            style="background-color: #5d04b0"
            :disabled="invalid"
            native-type="submit"
            >Lưu thông tin</el-button
          >
        </div>
      </el-form>
    </div>
    <div v-else class="loading-wrapper">
      <div class="dot-ring-loader mb-4">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div v-if="displayTime" class="">
        {{ displayTime }}
      </div>
      <p class="font-weight-medium text-center">
        Phiếu đăng ký sẽ được duyệt trong khoảng 10 phút.
      </p>
    </div>
  </ValidationObserver>
</template>

<script>
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";
import { CHANGE_DESTINATION } from "@/core/services/store/contract/contractOnline.module";

import moment from "moment-timezone";

extend("required", required);
extend("email", email);

export default {
  name: "ChangeAccountPayment",
  components: {
    ValidationObserver,
  },
  props: {
    contract: Object,
    payment_option: Object,
    is_show: Boolean,
  },
  data() {
    return {
      reason: "",
      currentTime: "",
      loadingAccept: false,
      displayTime: "",
      countupInterval: null,
      startTimestamp: null,
    };
  },

  mounted() {
    this.checkPayment(this.contract?.payment_options?.time_accept);
    const savedStart = localStorage.getItem("paymentStartTime");
    if (savedStart) {
      this.startCountup(parseInt(savedStart));
    }
  },

  watch: {
    is_show(newVal) {
      if (newVal) {
        this.checkPayment(this.contract.payment_options?.time_accept);
      }
    },
  },

  methods: {
    checkPayment(timeAccept) {
      const birthday = this.contract.birthday;
      if(birthday){
       this.contract.birthday = moment(birthday).format('YYYY-MM-DD')
      }
      if (timeAccept) {
        const current = moment(new Date());
        const today = moment(timeAccept);
        if (current.isAfter(today)) {
          this.loadingAccept = false;
        } else {
          this.loadingAccept = true;
        }
      }
    },

    onSubmit() {
      if ((this.reason?.length ?? 0) < 200) {
        this.$notify({
          title: "Có lỗi xảy ra!",
          message: "Lý do thay đổi tài khoản thanh toán phải tối thiểu 200 ký tự",
          type: "warning",
        });
        return;
      }
      
      const payload = {
        branch_id: this.contract.branch_id,
        payment_option_id: this.contract?.payment_options?.id || this.payment_option.id,
        transferDestination: this.contract?.payment_options?.transfer_destination || this.payment_option?.transfer_destination,
        contract_id: this.contract.id,
        reason: this.reason,
        amount: this.contract,
      };
      
      this.$store.dispatch(CHANGE_DESTINATION, payload).then((res) => {
        this.paymentOption = res.data;
        this.loadingAccept = true;
        this.reason = "";
        this.$emit("changeWaitingAccept");
        const key = `paymentStartTime_${this.contract.id}`;
        localStorage.setItem(key, Date.now().toString());
        this.startCountup(Date.now(), key, res.data);
      });
    },

    startCountup(startTime, storageKey, paymentOption) {
      const interval = setInterval(() => {
        const now = Date.now();
        const elapsed = now - startTime;

        if (elapsed >= 10 * 60 * 1000) {
          localStorage.removeItem(storageKey);
          clearInterval(interval);
          this.$emit("changeQrCode", paymentOption);
          this.loadingAccept = false;
          return;
        }

        const minutes = Math.floor(elapsed / 60000);
        const seconds = Math.floor((elapsed % 60000) / 1000);
        this.displayTime = `${String(minutes).padStart(2, "0")}:${String(
          seconds
        ).padStart(2, "0")}`;
      }, 1000);
    },

    close() {
      this.$emit("close");
    },
  },
};
</script>

<style>
.loading-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 250px; /* đảm bảo có chiều cao để căn giữa */
}

.dot-ring-loader {
  display: inline-block;
  position: relative;
  width: 40px;
  height: 40px;
}
.dot-ring-loader div {
  position: absolute;
  width: 6px;
  height: 6px;
  background: #f2c94c;
  border-radius: 50%;
  animation: dot-ring-spin 1.2s linear infinite;
}
.dot-ring-loader div:nth-child(1) {
  top: 0px;
  left: 18px;
  animation-delay: 0s;
}
.dot-ring-loader div:nth-child(2) {
  top: 5px;
  left: 28px;
  animation-delay: -0.1s;
}
.dot-ring-loader div:nth-child(3) {
  top: 14px;
  left: 32px;
  animation-delay: -0.2s;
}
.dot-ring-loader div:nth-child(4) {
  top: 23px;
  left: 28px;
  animation-delay: -0.3s;
}
.dot-ring-loader div:nth-child(5) {
  top: 28px;
  left: 18px;
  animation-delay: -0.4s;
}
.dot-ring-loader div:nth-child(6) {
  top: 23px;
  left: 5px;
  animation-delay: -0.5s;
}
.dot-ring-loader div:nth-child(7) {
  top: 14px;
  left: 0px;
  animation-delay: -0.6s;
}
.dot-ring-loader div:nth-child(8) {
  top: 5px;
  left: 5px;
  animation-delay: -0.7s;
}

@keyframes dot-ring-spin {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(0.5);
    opacity: 0.3;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
